import React from 'react';
import { connect } from 'dva';
import PropTypes from 'prop-types';
import styles from './FeatureDetailNotes.module.scss';
import { NOTEABLE_TYPES } from '../../../../lib/constants';
import NotesPanel from '../../Panel/Notes';

const FeatureDetailNotes = (props) => {
  return (
    <div className={styles.notesContainer}>
      <NotesPanel
        isOwner={props.selectedFeature.isOwner}
        noteableType={NOTEABLE_TYPES.Feature}
        noteableId={props.selectedFeature.uuid}
      />
    </div>
  );
};

FeatureDetailNotes.propTypes = {
  selectedFeature: PropTypes.object
};

export default connect((model) => ({
  selectedFeature: model.features.selectedFeature
}))(FeatureDetailNotes);